import React from "react";
import {
  Container,
  Grid,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  Button,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import * as gkApi from "../../api/gkApi";
import ScrollToTopBtn from "../common/ScrollToTop";

class GKQuarters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      years: [],
      year: "",
      page: 0,
      rowsPerPage: 10,
    };
  }

  async componentDidMount() {
    try {
      const years = await gkApi.getYears();
      years.sort((a, b) => b - a);
      const year = years[0];
      this.setState({ years, year });
      this.getQuarters(year);
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getQuarters = async (year) => {
    const list = await gkApi.getQuarters(year);
    if (list) {
      this.setState({ list });
    } else {
      this.setState({ list: [] });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    const year = e.target.value;
    await this.setState({ year });
    this.getQuarters(year);
  };

  handledownload = async () => {
    const excelfile = await gkApi.getExcelFileQuarters(this.state.year, true);
    if (excelfile === false) {
      toast.error("Ingen data");
    }
  };

  render() {
    const layoutStyle = {
      width: "100%",
      paddingTop: 80,
      margin: "auto",
    };

    const paperStyle = {
      width: "100%",
      padding: 20,
    };

    const tableWrapperStyle = {
      marginTop: 10,
      overflow: "auto",
    };

    const headDarkStyle = {
      backgroundColor: "#e6e6e6",
      fontWeight: "bold",
      fontSize: 16,
    };

    const headLightStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };

    const buttonStyle = {
      marginTop: 30,
      marginBottom: 20,
      float: "right",
    };

    const formControlStyle = {
      minWidth: "70%",
      marginLeft: 20,
    };

    const emptyPaperStyle = {
      textAlign: "center",
      verticalAlign: "middle",
      lineHeight: 20,
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layoutStyle}>
            <Paper style={paperStyle}>
              <React.Fragment>
                <Typography variant="h5">
                  Grønt kort korrespondenter - meldte skader og erstaningsbeløp
                  fordelt på selskap og kvartal
                </Typography>
                <Grid container>
                  <Typography variant="h6">Velg:</Typography>
                  <Grid item lg={4} style={{ marginLeft: 40 }}>
                    <FormControl variant="standard" style={formControlStyle}>
                      <InputLabel>År</InputLabel>
                      <Select
                        name="year"
                        value={this.state.year || ""}
                        onChange={this.handleChange}
                        fullWidth
                      >
                        {this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CloudDownloadIcon />}
                      onClick={this.handledownload}
                      style={buttonStyle}
                    >
                      Vis i Excel
                    </Button>
                  </Grid>
                  <Grid item lg={12}>
                    {this.state.list && this.state.list.length > 0 ? (
                      <Paper style={{ width: "100%", marginTop: 10 }}>
                        <div style={tableWrapperStyle}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                <TableCell style={headLightStyle}>
                                  Bedriftsnavn
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={2}
                                  style={headDarkStyle}
                                >
                                  1. kvartal
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={2}
                                  style={headLightStyle}
                                >
                                  2. kvartal
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={2}
                                  style={headDarkStyle}
                                >
                                  3. kvartal
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={2}
                                  style={headLightStyle}
                                >
                                  4. kvartal
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell style={headLightStyle}></TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Antall
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Erstatning
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Antall
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Erstatning
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Antall
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Erstatning
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Antall
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Erstatning
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.list
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage +
                                  this.state.rowsPerPage
                                )
                                .map((item, index) => (
                                  <TableRow hover key={index}>
                                    <TableCell>{item.companyName}</TableCell>
                                    <TableCell align="right">
                                      {item.q1qty.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q1compensation.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q2qty.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q2compensation.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q3qty.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q3compensation.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q4qty.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.q4compensation.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </div>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 50]}
                          component="div"
                          count={this.state.list.length}
                          rowsPerPage={this.state.rowsPerPage}
                          page={this.state.page}
                          onPageChange={this.handleChangePage}
                          onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                      </Paper>
                    ) : (
                      <Paper style={emptyPaperStyle}>Ingen treff</Paper>
                    )}
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default GKQuarters;
